export function AdminCarma({ carma }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Carma-Nachrichten ({carma.length})</h2>
      <div className="space-y-3">
        {carma.map((c) => (
          <div key={c.id} className="bg-gray-800 rounded-xl p-4">
            <div className="flex justify-between text-sm text-gray-400 mb-2">
              <span>
                <span className="text-blue-400">{c.senderName}</span>
                {' → '}
                <span className="text-green-400">{c.receiverName}</span>
              </span>
              <span>{new Date(c.createdAt).toLocaleString('de-DE')}</span>
            </div>
            <div className="text-white">{c.message}</div>
            {c.context && (
              <div className="text-gray-400 text-sm mt-1">Kontext: {c.context}</div>
            )}
          </div>
        ))}
        {carma.length === 0 && (
          <div className="text-gray-400">Noch keine Carma-Nachrichten</div>
        )}
      </div>
    </div>
  );
}
